













































































import Vue from 'vue'
import Expandable from '../utils/Expandable.vue'
import AceEditor from '../utils/AceEditor.vue'
import PluginPropVal from './pluginPropVal.vue'
export default Vue.extend({
  components:{
    Expandable,
    AceEditor,
    PluginPropVal
  },
  props:{
    value:{
      required:true
    },
    prop:{
      type:Object,required:true
    }
  },
  methods:{
    getCustomValues(): any{
      if(this.value!==null){
        const data = `${this.value}`
        const json = JSON.parse(data)
        return json
      }
      return []
    }
  }
})
